import * as DictionaryConstants from '../../../../../constants/DictionaryConstants'
import * as ReturnCodesConstants from '../../../../../constants/ReturnCodesConstants'
import * as RoutePathConstants from '../../../../../constants/RoutePathConstants'
import {mapActions, mapState} from 'vuex'
// import dateUtils from '../../../../common/utils/dateUtil'
import moment from 'moment'

export default {
  data () {
    return {
      pageNum: 1,
      pageSize: 10,
      pageOrder: 'desc',
      pageSort: 'id',
      centerHeight: document.documentElement.clientHeight - 40 +'px',
      type: '0',
      searchInput: '',
      myExtendedInsuranceData:[]
    }
  },
  computed: {
    ...mapState('myExtendedInsuranceModule', ['myOrderList'])
  },
  methods: {
    ...mapActions('myExtendedInsuranceModule', ['getMyExtendedInsurance']),
    dateFormat (time) {
      return time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : '-'
    }
  },
  mounted () {
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/my-extended-insurance/views/my-extended-insurance-details.js